export default "__VITE_ASSET__BN9$UIIT__"